<template>
  <slot />
  <Notifications position="top center" :group="'tailwind'">
    <template #body="props">
      <Toast
        class="mt-2 mr-6"
        :isError="props.item.data.isError"
        :isWarning="props.item.data.isWarning"
        :isNotice="props.item.data.isNotice"
        :isDisabled="props.item.data.isDisabled"
        :label="props.item.text"
        :onClick="props.close"
      />
    </template>
  </Notifications>

  <!-- Loading Overlay -->
  <LoadingOverlay
    v-if="isShowLoading"
    :isFlow="true"
    :isPulse="false"
    :isCircleFade="false"
  />
</template>

<script setup>
const isShowLoading = useIsShowLoading();
console.log('🚀 ~ isShowLoading:', isShowLoading.value);
</script>

<style lang="scss"></style>
